import axios from "axios";

const API_URL = "/api/teacher-assignments";

export const getTeacherAssignments = async (teacherId) => {
  const res = await axios.get(`${API_URL}/teacher/${teacherId}`);
  return res.data;
};

export const bulkAssignSubjects = async (assignmentData) => {
  const res = await axios.post(`${API_URL}/bulk`, assignmentData);
  return res.data;
};

export const deleteTeacherAssignment = async (id) => {
  const res = await axios.delete(`${API_URL}/${id}`);
  return res.data;
};
